import React from "react";

import {graph, graphHomeImage
} from '../../../../../images/index.js'

const features = [
  {
    number: "1",
    title: "Marketplace Intelligence",
    desc: "Get real-time analytics across platforms.",
  },
  {
    number: "2",
    title: "Hassle-Free Integration",
    desc: "Connect your seller accounts in minutes with zero coding. Our system auto-syncs your sales, returns, and payments.",
  },
  {
    number: "3",
    title: "Actionable Insights",
    desc: "Don’t just see numbers — understand them. Our smart suggestions help you cut costs, boost sales, and grow faster.",
  },
];

const WhyChooseUs = () => {
  return (
    <div className="why-container mb-lg-5 mt-lg-5">
          <h2 className="about-sub-heading text-center">Why Gapalyze Exists</h2>
          <div className="row g-4 mt-4">
          {/* Action over analysis */}
          <div className="col-md-3 col-lg-3">
            <div className="card gap-card h-100 text-start">
              <div className="card-body d-flex justify-content-between align-items-center flex-column flex-md-row">
                <div>
                  <h5 className="fw-bold card-heading">Action over analysis</h5>
                  <p className="fst-italic card-subheading">
                    End Less Insights that guide, not just numbers
                  </p>
                </div>
                {/* <div className="img-placeholder">
                  <img src={graphHomeImage} alt="graph" className="img-fluid" />
                </div> */}
              </div>
            </div>
          </div>

          {/* Clarity over confusion */}
          <div className="col-md-3 col-lg-3">
            <div className="card gap-card h-100 text-start">
              <div className="card-body d-flex justify-content-between align-items-center flex-column flex-md-row">
                <div>
                  <h5 className="fw-bold card-heading">Clarity over confusion</h5>
                  <p className="fst-italic card-subheading">Simple dashboards, not spreadsheets</p>
                </div>
                {/* <div className="img-placeholder">
                  <img src={graphHomeImage} alt="graph" className="img-fluid" />
                </div> */}
              </div>
            </div>
          </div>

          {/* Trust over doubt */}
          <div className="col-md-3 col-lg-3">
            <div className="card gap-card h-100 text-start">
              <div className="card-body d-flex justify-content-between align-items-center flex-column flex-md-row">
                <div>
                  <h5 className="fw-bold card-heading">Trust over doubt</h5>
                  <p className="fst-italic card-subheading">
                    100% private, secure data for every seller
                  </p>
                </div>
                {/* <div className="img-placeholder">
                  <img src={graphHomeImage} alt="graph" className="img-fluid" />
                </div> */}
              </div>
            </div>
          </div>

          {/* 100% private, secure data */}
          <div className="col-md-3 col-lg-3">
            <div className="card gap-card h-100 text-start">
              <div className="card-body d-flex justify-content-between align-items-center flex-column flex-md-row">
                <div>
                  <h5 className="fw-bold card-heading">
                    100% private, secure data for every seller
                  </h5>
                  <p className="fst-italic card-subheading">
                    Focused insights that scale revenue & profit
                  </p>
                </div>
                {/* <div className="img-placeholder">
                  <img src={graphHomeImage} alt="graph" className="img-fluid" />
                </div> */}
              </div>
            </div>
          </div>
          </div>
    </div>
  );
};

export default WhyChooseUs;
